<script lang="ts">
    import { Booking } from "../../model/Booking";

    interface Props {
        booking: Booking;
    }

    let { booking }: Props = $props();
</script>

<div class="progress w-100 h-10px">
    <div
        class="progress-bar bg-success"
        role="progressbar"
        style="width: {Math.round(
            (booking.volumeSpent / booking.volumeTotal) *
                100,
        )}%"
        aria-valuenow={Math.round(
            (booking.volumeSpent / booking.volumeTotal) *
                100,
        )}
        aria-valuemin="0"
        aria-valuemax="100"
    ></div>
</div>
